import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'antd';
import { history } from '../../../config/history';

export const NotFound = () => (
    <div className="not-found">
        <div className="not-found__content">
            <h3 className="not-found__info">Ooops! You do not have permission to access this page :(</h3>
            <Button type="primary"><Link to="/Dashboard">Back to Dashboard</Link></Button>
            <Button onClick={history.goBack} style={{ marginLeft: 15 }}>Previous</Button>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/modules/App/components/NotFound.js